import React, { createContext, useContext, useState } from "react";

const SelectedClientContext = createContext(null);

export const useSelectedClient = () => {
  const context = useContext(SelectedClientContext);
  if (!context) {
    return { selectedClient: null, setSelectedClient: () => {} };
  }
  return context;
};

export const SelectedClientProvider = ({ children }) => {
  const [selectedClient, setSelectedClient] = useState(null);

  return (
    <SelectedClientContext.Provider value={{ selectedClient, setSelectedClient }}>
      {children}
    </SelectedClientContext.Provider>
  );
};
